<template>
  <div class="_root-can-use">
    <el-form
      size="small"
      :inline="true"
      :model="memberForm"
      class="demo-form-inline"
      style="margin: 5px 0 10px 0; text-align: right"
    >
      <el-form-item>
        <el-input style="width: 220px" v-model="memberForm.targetId" placeholder="账号"></el-input>
      </el-form-item>
      <el-form-item>
        <el-input style="width: 220px" v-model="memberForm.userName" placeholder="签署方名称"></el-input>
      </el-form-item>
      <el-form-item>
        <el-select v-model="memberForm.corpGroupId" placeholder="请选择部门" style="width: 150px">
          <el-option label="全部" :value="-1" />
          <el-option
            v-for="(item, index) in treeGroups"
            :key="index"
            :label="item.groupName"
            :value="item.corpGroupId"
          />
        </el-select>
      </el-form-item>
      <el-form-item style="margin-right: 0px">
        <el-button @click="getCmSealUsers()">查询</el-button>
        <el-button @click="reset">重置</el-button>
      </el-form-item>
    </el-form>
    <el-table
      ref="multipleTable"
      :row-key="(row) => row.corpUserId"
      :data="unSealUsers"
      height="50vh"
      style="border: 1px solid #eeeeee; border-bottom: 0; margin-top: -15px"
      tooltip-effect="dark"
      @row-click="handleRow"
      @selection-change="handleSelectionChange"
      :header-cell-style="{
        background: '#f9f9f9',
        color: '#333333',
        fontWeight: '600',
      }"
    >
      <el-table-column type="selection" width="55" :reserve-selection="true"></el-table-column>
      <el-table-column label="账号" show-overflow-tooltip prop="targetId"></el-table-column>
      <el-table-column label="名称" show-overflow-tooltip prop="userName"></el-table-column>
      <el-table-column label="部门" prop="groupNames" show-overflow-tooltip></el-table-column>
      <template slot="empty">
        <el-empty description="暂无数据"></el-empty>
      </template>
    </el-table>
    <el-row class="pageation page-box">
      <el-col :span="22" class="page-row page-flex-end">
        <el-pagination
          @size-change="approSizeChange"
          @current-change="approCurrentChange"
          :current-page="itemPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="sizes, prev, pager, next, total"
          :total="pageTotal"
        />
        <el-go
          :page-size="pageSize"
          :total="pageTotal"
          @current-change="approCurrentChange"
          style="margin-right: 115px; top: 7px"
        ></el-go>
      </el-col>
      <el-col :span="2" class="page-row">
        <el-button
          size="mini"
          type="primary"
          style="margin-top:2px"
          :disable="selectionRow.length === 0"
          @click="ChooseMember"
        >确认授权</el-button>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import ElGo from "@/components/go/Go";
// API
import { ApiCorpMethods } from "@/assets/js/http-serve/corp/http-methods";
export default {
  components: { ElGo },
  props: { rowData: { type: Object, default: {} } },
  data () {
    // 这里存放数据
    return {
      itemPage: 1,
      pageTotal: 0,
      pageSize: 10,
      treeGroups: [],
      unSealUsers: [],
      selectionRow: [],
      memberForm: {
        targetId: "",
        userName: "",
        corpGroupId: -1,
      },
    }
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    /** 表格行点击数据 */
    handleRow (row, column, event) {
      this.$refs.multipleTable.toggleRowSelection(row)
    },
    // 确认
    ChooseMember () {
      if (this.selectionRow.length === 0)
        return this.$message.warning("请选择使用人");
      const userIds = this.selectionRow.map(item => item.corpUserId)
      const data = {
        auth: 1,
        flowId: this.rowData.flowId,
        corpUserIdSet: userIds.toString()
      }
      this.$emit('changAuth', data, this.rowData)
      // 清空
      this.$refs.multipleTable.clearSelection()
      this.selectionRow = []
    },
    getCmSealUsers (auth) {
      const { targetId, userName, corpGroupId } = this.memberForm;
      const param = { auth: 0, targetId, userName, corpGroupId: corpGroupId === -1 ? '' : corpGroupId, itemPage: this.itemPage, pageSize: this.pageSize }
      if (this.rowData.flowId || this.rowData.flowId === 0) param.flowId = this.rowData.flowId
      // ApiCorpMethods.OrganizationController.listCorpUsers(param)
      ApiCorpMethods.FlowController.findflowByUserPaged(param)
        .then(res => {
          if (res.success) {
            this.unSealUsers = res.data;
            this.pageTotal = res.total;
          } else {
            this.$message.error(res.description);
          }
        })
        .catch(error => {
          this.$message.error(error.description);
        });
    },
    initTreeGroupApproval () {
      let params = {};
      params.permId = 4;
      ApiCorpMethods.OrganizationController.treeGroup(params)
        .then(res => {
          if (+res.code === 0) {
            this.convertFormateTree(res.data);
          } else {
            this.$message.error(res.description);
          }
        })
        .catch(error => {
          this.$message({ type: "error", message: error.description });
        });
    },
    convertFormateTree (tree) {
      tree.forEach(i => {
        this.treeGroups.push({
          corpGroupId: i.corpGroupId,
          groupName: i.groupName
        });
        if (i.childCorpGroups && i.childCorpGroups.length !== 0)
          this.convertFormateTree(i.childCorpGroups);
      });
    },
    handleSelectionChange (val) {
      this.selectionRow = val;
    },
    // 重置
    reset () {
      this.memberForm = {
        targetId: "",
        userName: "",
        corpGroupId: -1
      };
      this.itemPage = 1
      this.pageTotal = 0
      this.pageSize = 10
      this.getCmSealUsers();
    },
    approCurrentChange (val) {
      this.itemPage = val;
      this.getCmSealUsers();
    },
    approSizeChange (val) {
      this.pageSize = val;
      this.getCmSealUsers();
    },
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created () { this.initTreeGroupApproval() },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted () { this.getCmSealUsers() },
}
</script>

<style lang='less' scoped>
/* @import url(); 引入公共css类 */
._root-can-use {
  padding-bottom: 10px;
  .page-box {
    display: flex;
    justify-content: flex-end;
  }
  .page-row {
    padding: 5px 0;
  }
  .warn-img {
    color: #f8b762;
  }
}
</style>



// WEBPACK FOOTER //
// pages/console/components/contractApproval/scopeUse.vue